import { Global } from "@emotion/react";

import type {
  ButtonTemplateSettings,
  EmailButtonSettings,
} from "../email-design/types/email-button-settings";
import type { CSSObject } from "@emotion/react";
import type { FC } from "react";
import type { DeepPartial } from "react-hook-form";

export const emailButtonStyles = (
  buttonSetting?: DeepPartial<ButtonTemplateSettings>,
): CSSObject => ({
  color: buttonSetting?.color,
  backgroundColor: buttonSetting?.background_color,
  fontSize: buttonSetting?.font_size,
  border: `${buttonSetting?.border ?? 0}px solid ${buttonSetting?.color}`,
  borderRadius: `${buttonSetting?.border_radius}px`,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
});

export const EmailButtonStyles: FC<{ buttons: DeepPartial<EmailButtonSettings> }> = ({
  buttons,
}) => (
  <Global
    styles={{
      "button.primary_button": emailButtonStyles(buttons.primary_button),
      "button.secondary_button": emailButtonStyles(buttons.secondary_button),
    }}
  />
);
